import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

export interface DTabsProps extends TabsProps {}

export const DarwinTabs = (props: DTabsProps) => {
  return <Tabs {...props} />;
};
